export enum OrderTypeIncludeNamePrefix {
	NONE = 0,
	FOR = 1,
	NAME = 2,
	ORDER = 3,
	GUEST = 4,
}
